module.exports = "/_next/static/images/step1-0280d3427471ceada6e6529559b42888.png";